import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="section-pad bg-background-50">
      <div className="container-page">
        <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-14 text-center md:py-16">
          <div
            className="absolute inset-0 bg-cover bg-center opacity-25"
            style={{
              backgroundImage:
                "url('https://readdy.ai/api/search-image?query=Pop%20art%20comic%20style%20illustration%20background%20with%20floating%20laughing%20emoji%20faces%20comic%20stars%20and%20confetti%20in%20coral%20yellow%20and%20teal%20palette%2C%20bold%20outlines%20flat%20style%2C%20energetic%20happy%20mood%2C%20no%20text&width=1400&height=500&seq=cta-ww&orientation=landscape')",
            }}
            aria-hidden="true"
          />
          <div className="relative z-10">
            <h2 className="text-3xl text-background-50 md:text-4xl">别犹豫了，今天就开追！</h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-background-100">
              全站免费、每日更新，点开就是快乐的开始。歪歪一下，烦恼全消。
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/category/hot"
                className="whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-accent-300"
              >
                进入最新更新
              </Link>
              <Link
                to="/category"
                className="whitespace-nowrap rounded-full border border-background-100/70 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览全部分类
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}